type CopyrightIconProps = {
  className: string
}

export const CopyrightIcon = ({ className }: CopyrightIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3Z"
      stroke="#1A1814"
      strokeWidth="1.85"
      strokeLinecap="round"
    />
    <path
      d="M12.1213 7.87868C11.7017 7.45912 11.1672 7.1734 10.5852 7.05764C10.0033 6.94189 9.40009 7.0013 8.85191 7.22836C8.30374 7.45542 7.8352 7.83994 7.50556 8.33329C7.17591 8.82664 6.99996 9.40666 6.99996 10C6.99996 10.5933 7.17591 11.1734 7.50556 11.6667C7.8352 12.1601 8.30374 12.5446 8.85191 12.7716C9.40009 12.9987 10.0033 13.0581 10.5852 12.9424C11.1672 12.8266 11.7017 12.5409 12.1213 12.1213"
      stroke="#1A1814"
      strokeWidth="1.85"
      strokeLinecap="round"
    />
  </svg>
)
